import React from "react";

function DTOGoalsRatio() {
  return <></>;
}
export default DTOGoalsRatio;
